import React, { useEffect, useRef, useState } from 'react';
import { Cookies } from '../../../../index.js';
import Getlink from './Getlink';
import Countdown from './Countdown';
import InfoLink_cilent from './info_link';
import InfoLink_admin from './../admin/info_link';
import { alert_error, alert_success } from '../../../../AppContext';
import Language_i18 from '../../../../js/useNationalLanguage.jsx';

/**
 * DataJop component
 * Props:
 * - data: array of items
 * - nutxuly, category, service, mission, link, laymisson,
 * - gtoken, setgtoken, htoken, sethtoken,
 * - dataToSend, receiveDataFromChild, setnutxuly, startjop, handleSubmit
 * 
 * Auto-scroll to id_data_view from cookie if exists, otherwise URL param.
 */
export default function DataJop({
    data,
    nutxuly,
    category,
    service,
    mission,
    link,
    laymisson,
    gtoken,
    setgtoken,
    htoken,
    sethtoken,
    dataToSend,
    receiveDataFromChild,
    setnutxuly,
    startjop,
    handleSubmit,
    set_data_edit,
    nutorder,
}) {
    const { i18n, lang } = Language_i18();

    const itemRefs = useRef({});
    const [viewId, setViewId] = useState(null);

    // On mount: read cookie first, then URL param
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const status_message = params.get('status_message');
        if (status_message) {
            alert_success(status_message);
        }
        console.log(Cookies.get('id_data_view'));

        const cookieId = Cookies.get('id_data_view');
        if (cookieId) {
            Cookies.remove('id_data_view');
            setViewId(cookieId);
        } else {
            const paramId = params.get('id_data_view');
            if (paramId) setViewId(paramId);
        }
    }, []);

    // When viewId changes, scroll to element
    useEffect(() => {
        if (viewId && itemRefs.current[viewId]) {
            itemRefs.current[viewId].scrollIntoView({ behavior: 'auto', block: 'center' });
        }
    }, [viewId]);
    function getDisplayName(item) {
        if (!item || !item.name) return '';

        let nameObj;
        if (typeof item.name === 'string') {
            try {
                const parsed = JSON.parse(item.name);
                nameObj = typeof parsed === 'object' && parsed !== null ? parsed : { en: item.name };
            } catch {
                nameObj = { en: item.name };
            }
        } else {
            nameObj = item.name;
        }
        return nameObj[lang] || nameObj.en || '';
    }

    const sortedData = React.useMemo(() => {
        return [...data].sort((a, b) => {
            if ((a.views ?? 0) === 0 && (b.views ?? 0) !== 0) return 1;
            if ((a.views ?? 0) !== 0 && (b.views ?? 0) === 0) return -1;
            return 0;
        });
    }, [data]);

    return (

        <div className="flex flex-wrap">
            {sortedData.map((item, index) => {
                const idKey = item.id.toString();
                return (
                    <div
                        key={idKey}
                        ref={el => { itemRefs.current[idKey] = el; }}
                        className={`pb-2 sm:pb-2 md:pb-3 mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 pr-3 pl-3 ${index > 0 && index % 4 === 0 ? 'clear-left' : ''
                            }`}
                    >
                        <div className="border px-3 pt-2 pb-1 rounded-lg bg-white shadow-lg">
                            <button
                                disabled={nutxuly == 1 || item.time_delay}
                                onClick={() => handleSubmit(item)}
                                className="flex justify-between items-center mb-0 w-full">
                                <p className="font-bold text-lg">{getDisplayName(item)}</p>
                                {/* <p className="font-bold text-lg">{item.id}</p> */}
                                <div className="rounded-full bg-pink-500 p-2">
                                    {nutxuly == 1 && (<div className="h-8 w-8 ">
                                        <span className="spinner-border spinner-border-xs  "></span>
                                    </div>)}
                                    {
                                        nutxuly == 0 && item.time_delay ? (<>
                                            <Countdown timeDelay={item.time_delay}
                                                laymisson={laymisson} value={item.id} />
                                        </>) : (
                                            nutxuly == 0 && (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </>
                                            )
                                        )
                                    }
                                </div>
                            </button>

                            {
                                category == 'hustadmin' ? (<>
                                    <InfoLink_admin item={item} set_data_edit={set_data_edit} />
                                </>) : (<>
                                    <InfoLink_cilent item={item} />
                                </>)
                            }


                            {
                                service == item.id &&
                                (
                                    <>
                                        {mission ? (<>   <div className="flex items-center justify-center">
                                            <a href={link} target="_blank" >
                                                <button onClick={(event) => startjop(event)} className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition duration-300 ease-in-out">
                                                    Try Now
                                                </button>
                                            </a>
                                        </div></>) :
                                            (
                                                <><div className="mt-0">
                                                    {nutorder}
                                                    <Getlink gtoken={gtoken} setgtoken={setgtoken} service={item.id} htoken={htoken} sethtoken={sethtoken} data={dataToSend} sendDataToParent={receiveDataFromChild} nutxuly={nutxuly} setnutxuly={setnutxuly} />
                                                </div></>

                                            )
                                        }

                                    </>

                                )
                            }

                        </div>
                    </div>
                );
            })}
        </div>
    );
}
